import { render, staticRenderFns } from "./MedTable.vue?vue&type=template&id=41ebc59c&scoped=true"
import script from "./MedTable.vue?vue&type=script&lang=js"
export * from "./MedTable.vue?vue&type=script&lang=js"
import style0 from "./MedTable.vue?vue&type=style&index=0&id=41ebc59c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ebc59c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ebc59c')) {
      api.createRecord('41ebc59c', component.options)
    } else {
      api.reload('41ebc59c', component.options)
    }
    module.hot.accept("./MedTable.vue?vue&type=template&id=41ebc59c&scoped=true", function () {
      api.rerender('41ebc59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/MedTable.vue"
export default component.exports